module.exports = __webpack_public_path__ + "static/media/image_16.f2798d94.png";